import FullscreenModal from './FullscreenModal';
import './FullscreenModal.scss';

export default FullscreenModal;
